import React from 'react'

import TenantService from 'App/services/tenant'

const h2Style = { maxWidth: 405 }

const NotFoundRestaurantMenuPage = () => {
  return (
    <header className="masthead">
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center text-center">
          <div className="col-lg-10 align-self-end">
            <h1 className="title text-white font-weight-bold">
              Strona nie istnieje{' '}
              <svg
                className="svg-inline--fa fa-frown fa-w-16"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="frown"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 496 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                />
              </svg>{' '}
            </h1>
            <hr className="divider my-4" />
          </div>
          <div className="col-lg-8 align-self-baseline">
            <div className="reservation-data-overlay">
              <h2 className="h5" style={h2Style}>
                Nie znaleźliśmy tej strony, ale możesz{' '}
                <a href="/zamawiaj">zamówić coś dobrego</a>
                {!TenantService.isTenantWithDefaultOrderMode() && (
                  <>
                    , lub{' '}
                    <a href="/restaurants?mode=book">zarezerwować stolik</a>
                  </>
                )}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

NotFoundRestaurantMenuPage.displayName = 'NotFoundRestaurantMenuPage'

export default NotFoundRestaurantMenuPage
